import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";
import { getMenuLanguages } from "@/api/tenant";

// Menü dilleri tek kaynaktan: platformun KATALOĞU (Language tablosu) + bu kiracının açtıkları.
//
// Panelde sabit dil listesi YOK. Eskiden lib/menuLang'de üç satır duruyordu ve aynı liste menüde,
// API'nin çeviri ucunda ve şemada ayrı ayrı tekrar ediyordu — bir dil eklemek beş yeri değiştirmekti.
// Fransızca artık katalogda: kiracı Ayarlar'dan işaretliyor, panel deploy'u gerekmiyor.
//
// staleTime uzun: katalog gün içinde değişmiyor ve bu kanca ürün/kategori formlarının her açılışında
// çalışıyor.
export const useMenuLanguages = () => {
  const { data, isPending } = useQuery({
    queryKey: ["menu-languages"],
    queryFn: getMenuLanguages,
    staleTime: 60 * 60 * 1000,
  });

  // Dönen diziler useMemo'lu: tüketiciler bunları effect bağımlılığı olarak kullanıyor (form
  // alanları dil listesinden türetiliyor). Her render'da yeni referans üretilirse o effect'ler
  // sonsuz döner.
  return useMemo(() => {
    const catalog = data?.catalog ?? [];
    const selected = data?.selected ?? [];
    const baseCode = data?.baseCode ?? null;
    const byCode = new Map(catalog.map((item) => [item.code, item]));

    return {
      loading: isPending,
      catalog,
      selectedCodes: selected,
      baseCode,
      base: byCode.get(baseCode) ?? null,
      // Çeviri girilebilecek diller: kiracının açtıkları EKSİ taban dil. Taban zaten formun
      // kendi alanlarında (ad, açıklama) yazılıyor, ikinci kez sorulmamalı. Sıra kiracının
      // seçim sırası — menüdeki dil seçici ve form sekmeleri aynı düzende olsun; katalogda
      // olmayan kod (dil pasife alınmış) sessizce eleniyor.
      contentLanguages: selected
        .filter((code) => code !== baseCode)
        .map((code) => byCode.get(code))
        .filter(Boolean),
    };
  }, [data, isPending]);
};
